import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {ProgramService} from '../../../services/vpp/program.service';
import {Program, Programs} from '../../../domain/cloud-topology';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DataService} from '../../../services/data.service';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-program-home',
    templateUrl: './program-home.component.html',
    standalone: false
})
export class ProgramHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  programs: Program[];
  private subject$: Subject<void>;
  tab: string;
  @ViewChild(MatTabGroup) matTabGroup: MatTabGroup;

  constructor(private programService: ProgramService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void  {
    this.subject$ = new Subject<void>();
    this.programService.getPrograms().pipe(takeUntil(this.subject$)).subscribe(async programs => {
      this.programs = Programs.sortAlphabetically(programs);
      await this.queryTab();
    });
  }

  ngAfterViewInit() {
    this.tab = this.route.snapshot.queryParams['tab'];
  }

  async queryTab(): Promise<void> {
    if (this.tab) {
      this.matTabGroup.selectedIndex = this.tab === 'dispatches' ? 0 : 1;
    } else {
      await this.changeTab('dispatches');
    }

    this.matTabGroup.selectedTabChange.subscribe(tabEvent => {
      this.changeTab(tabEvent.tab.textLabel.toLowerCase());
    })
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }

  async changeTab(tab: string): Promise<void> {
    this.tab = tab;
    await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab: this.tab,
      },
      queryParamsHandling: 'merge',
    });
  }

  processRemovedProgram($event): void {
    const newProgramCollection = [];
    for (const program of this.programs) {
      if (program.id !== $event.id) {
        newProgramCollection.push(program);
      }
    }

    this.dataService.setPrograms(newProgramCollection);
  }

  processNewProgram($event): void {
    this.dataService.setPrograms(this.programs);
  }
}
